var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8784 13.3713C17.7113 12.4728 17.744 11.5485 17.9743 10.6641C18.2047 9.77965 18.6269 8.95677 19.2111 8.25391C19.7952 7.55104 20.527 6.98543 21.3544 6.59724C22.1818 6.20905 23.0845 6.00781 23.9984 6.00781C24.9124 6.00781 25.8151 6.20905 26.6425 6.59724C27.4699 6.98543 28.2016 7.55104 28.7858 8.25391C29.37 8.95677 29.7922 9.77965 30.0225 10.6641C30.2528 11.5485 30.2856 12.4728 30.1184 13.3713L27.5504 27.0513C27.3939 27.8788 26.9534 28.6257 26.3049 29.163C25.6564 29.7003 24.8406 29.9944 23.9984 29.9944C23.1563 29.9944 22.3405 29.7003 21.692 29.163C21.0435 28.6257 20.603 27.8788 20.4464 27.0513L17.8784 13.3713ZM28.4984 37.5003C28.4984 38.6938 28.0243 39.8384 27.1804 40.6823C26.3365 41.5262 25.1919 42.0003 23.9984 42.0003C22.805 42.0003 21.6604 41.5262 20.8165 40.6823C19.9725 39.8384 19.4984 38.6938 19.4984 37.5003C19.4984 36.3069 19.9725 35.1623 20.8165 34.3183C21.6604 33.4744 22.805 33.0003 23.9984 33.0003C25.1919 33.0003 26.3365 33.4744 27.1804 34.3183C28.0243 35.1623 28.4984 36.3069 28.4984 37.5003Z",
    fill: "#FFC000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8062e023c4e18db1a6e54e1003ff49ba.svg";
export { ForwardRef as ReactComponent };